export const UISETTINGS = {
  UPDATE_USER: 'uisettings/UPDATE_USER',
} as const;
